module.exports = require('./helpers/bundle-url').getBundleURL('kSbYx') + "logo-dark.eefe0b7f.svg";